<template>
  <PanelV2
    type="w3"
    mode="simple"
  >
    <template v-slot:content-solt>
      <img src="@/assets/pc/sent-email.svg" />
      <span class="tip-title">Please check your email</span>
      <span class="tip-desc">To continue with your application, please click the link we sent to your email.</span>
    <!-- <el-button class="continue_btn" type="info" disabled >Continue</el-button> -->
    <p class="bottom_txt">Did not receive the link? <span @click="sendEmail">Resend email</span></p>
    </template>
  </PanelV2>
</template>

<script>
  import API from "@/api";
  export default {
    name: 'CheckYourEmail',
    pRouter: 'App',
    data() {
      return {
      }
    },
    created() {
      // this.init()
    },
    methods: {
      sendEmail() {
        API.sendEmail({
          token: this.getCookieItem("token"),
        }).then(res => {
          if(res.success) {
            sessionStorage.clear()
          }
        })
      }
    }
  }
</script>


<style lang="scss" scoped>
  .continue_btn {
    width: 330px;
  }

  .tip-title {
    margin: 16px 0 0;
    font: normal normal normal 24px/30px Nunito-bold;
    letter-spacing: 0px;
    color: #2E2E2E;
  }

  .tip-desc {
    margin: 16px 0 0;
    font: normal normal normal 15px/20px Nunito;
    letter-spacing: 0px;
    color: #2E2E2E;
  }

  .bottom_txt {
    margin-top: 16px;
    span {
      color: #0072D8;
      cursor: pointer;
    }
  }
</style>
